import Vue from 'vue';
import Brand from '@/services/Brand';
// @ts-ignore
import Amplify, * as AmplifyModules from 'aws-amplify';

import { AmplifyPlugin } from '@/pages/Auth/AmplifyPlugin';

const Auth: any = {
     region: 'us-west-2',
     // OPTIONAL - Amazon Cognito User Pool ID
     userPoolId: process.env.VUE_APP_COGNITO_POOL_ID,
     // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
     userPoolWebClientId: Brand.getClientID(),
};

// if (Brand.getBrand() === 'mmic') {
//      Auth.Auth.authenticationFlowType = 'CUSTOM_AUTH';
// }

AmplifyModules.Auth.configure({
     ...Auth,
});

AmplifyModules.Analytics.configure({ disabled: true });

Vue.use(AmplifyPlugin, AmplifyModules);

export { AmplifyModules };
